import { render, staticRenderFns } from "./HeadImage.vue?vue&type=template&id=059b8495&scoped=true&"
import script from "./HeadImage.vue?vue&type=script&async=true&lang=js&"
export * from "./HeadImage.vue?vue&type=script&async=true&lang=js&"
import style0 from "./HeadImage.vue?vue&type=style&index=0&id=059b8495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b8495",
  null
  
)

export default component.exports